<template>
  <manifest />
</template>

<script>
import Manifest from "@/components/3pl/Operations/Dispatch/manifest.vue";

export default {
  components: {
    Manifest,
  },
};
</script>

<style></style>